import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import {
  Button,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuList,
  Paper,
  Popper,
  Theme,
  Typography,
} from '@material-ui/core';
import { SelectIcon } from 'asset/images';
import { PageReturnOptions, SeasonOptions } from 'components/SelectOptions';
import { PageReturnSelectProps, SeasonSelectProps } from 'components/Select/type';
import CodeVO from 'commons/vo/CodeVO';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    border: '1px solid #b6b6b6',
    borderRadius: 0,
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
    width: 'calc(100% - 130px)',
  },
  paper: {
    borderRadius: 0,
    maxHeight: '250px',
    overflowY: 'scroll',
  },
}));

function SeasonSelect({ seasonId, seasonList, onChangeSeason }: SeasonSelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const selectedSeason = useMemo(() => {
    return seasonList.find((season: CodeVO) => String(season.id) === seasonId);
  }, [seasonList, seasonId]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography>{selectedSeason?.name || '모두'}</Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <SeasonOptions
                    seasonId={seasonId}
                    seasonList={seasonList}
                    onClose={onCloseMenu}
                    onChangeSeason={onChangeSeason}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default SeasonSelect;
